<script lang="ts">
  interface Props {
    selectedZona: string;
    zonas: string[];
    onZonaChange: (zona: string) => void;
  }

  let { selectedZona, zonas, onZonaChange }: Props = $props();
  let showProfileMenu = $state(false);
  let showZonaMenu = $state(false);

  function handleZonaSelect(zona: string) {
    onZonaChange(zona);
    showZonaMenu = false;
  }

  function toggleProfileMenu() {
    showProfileMenu = !showProfileMenu;
  }

  function toggleZonaMenu() {
    showZonaMenu = !showZonaMenu;
  }

  function handleLogout() {
    // Dispatcher logout - just reload to clear state and return to dashboard
    window.location.href = '/';
  }

  function getZonaLabel() {
    return selectedZona || 'Todas las zonas';
  }
</script>

<header class="px-4 py-3 flex items-center justify-between z-50 bg-[#0066CC] flex-shrink-0">
  <div class="flex items-center gap-3">
    <div class="flex items-center gap-1.5 px-3 py-1 bg-white/20 rounded-full">
      <div class="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
      <span class="text-xs font-bold text-white">Recibiendo conductores en vivo</span>
    </div>
  </div>

  <div class="flex items-center gap-[15px]">
    <!-- Zona Dropdown -->
    <div class="relative">
      <button
        onclick={toggleZonaMenu}
        class="flex items-center gap-1.5 px-3 py-1.5 bg-white text-black rounded-lg text-xs font-bold transition hover:bg-gray-100"
      >
        <span>{getZonaLabel()}</span>
        <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
          <path d="M7 10l5 5 5-5z"/>
        </svg>
      </button>

      {#if showZonaMenu}
        <div class="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-lg z-50">
          <button
            onclick={() => handleZonaSelect('')}
            class="w-full px-4 py-2 text-left text-sm font-bold text-black hover:bg-gray-100 transition first:rounded-t-lg"
          >
            Todas las zonas
          </button>
          {#each zonas as zona (zona)}
            <button
              onclick={() => handleZonaSelect(zona)}
              class="w-full px-4 py-2 text-left text-sm font-bold text-black hover:bg-gray-100 transition {selectedZona === zona ? 'bg-gray-200' : ''}"
            >
              {zona}
            </button>
          {/each}
        </div>
      {/if}
    </div>

    <!-- Profile Menu -->
    <div class="relative">
      <button
        onclick={toggleProfileMenu}
        class="w-8 h-8 rounded-full bg-white hover:bg-gray-100 flex items-center justify-center transition"
        aria-label="Perfil de usuario"
      >
        <svg class="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </svg>
      </button>

      <!-- Dropdown Menu -->
      {#if showProfileMenu}
        <div class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg z-50">
          <!-- User Info -->
          <div class="px-4 py-3 border-b border-gray-200">
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 rounded-full bg-green-500"></div>
              <span class="text-sm font-bold text-gray-800">Conectado</span>
            </div>
            <p class="text-xs text-gray-600 mt-1">Despachador Web</p>
          </div>

          <!-- Logout Button -->
          <button
            onclick={handleLogout}
            class="w-full px-4 py-2 text-left text-sm font-bold text-red-600 hover:bg-red-50 transition flex items-center gap-2"
          >
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
            </svg>
            Cerrar sesión
          </button>
        </div>
      {/if}
    </div>
  </div>
</header>
